import { useState } from 'react';
import CouponService from './CouponService';

function useManageCoupons() {
    const [coupons, setCoupons] = useState([]);
    const [tiers, setTiers] = useState([]);
    const [grantHistory, setGrantHistory] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const refreshCoupons = async () => {
        setIsLoading(true);
        try {
            const response = await CouponService.getCoupons();
            setCoupons(response.data.data || []);
            setError(null);
        } catch (err) {
            console.log(err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const createCoupon = async (couponData) => {
        await CouponService.createCoupon(couponData);
        await refreshCoupons();
    };

    const editCoupon = async (couponId, updatedData) => {
        await CouponService.editCoupon(couponId, updatedData);
        await refreshCoupons();
    };

    const deactivateCoupon = async (couponId) => {
        await CouponService.deleteCoupon(couponId);
        await refreshCoupons();
    };

    const grantCoupon = async (payload) => {
        return await CouponService.grantCoupon(payload);
    };

    // Returns { user, coupons } for the searched customer (user is null if not found).
    const searchCustomer = async (search) => {
        const response = await CouponService.getCustomerCoupons({ search });
        return { user: response.data.user, coupons: response.data.data || [] };
    };

    const refreshGrantHistory = async () => {
        try {
            const response = await CouponService.getGrantHistory();
            setGrantHistory(response.data.data || []);
        } catch (err) {
            console.log(err);
        }
    };

    const refreshTiers = async () => {
        try {
            const response = await CouponService.getTiers();
            setTiers(Array.isArray(response.data) ? response.data : []);
        } catch (err) {
            console.log(err);
        }
    };

    return {
        coupons,
        tiers,
        grantHistory,
        isLoading,
        error,
        refreshCoupons,
        createCoupon,
        editCoupon,
        deactivateCoupon,
        grantCoupon,
        searchCustomer,
        refreshGrantHistory,
        refreshTiers
    };
}

export default useManageCoupons;
